<!-- 我的直播 -->

<template>
  <div class="main">
    <!-- 顶部搜索 -->
    <div class="s_wrapper">
      <el-input class="s_input" placeholder="搜索直播名称" suffix-icon="el-icon-search" v-model="liveName" :clearable="true"
        @change="onSearch"></el-input>
      <el-select v-model="status" placeholder="选择直播状态" clearable @change="onSearch">
        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <div class="globle_border" v-loading="loading">
      <!-- 表格 -->
      <div class="g_table">
        <el-table :data="tableData" style="width: 100%" max-height="540">
          <el-table-column label="序号" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column min-width="270" show-overflow-tooltip prop="liveName" label="直播名称"></el-table-column>
          <el-table-column min-width="160" show-overflow-tooltip prop="categoryName" label="直播分类"></el-table-column>
          <el-table-column min-width="160" prop="buyerCount" show-overflow-tooltip label="预约人数"> </el-table-column>
          <el-table-column min-width="180" show-overflow-tooltip prop="startTime" label="直播开始时间"></el-table-column>
          <el-table-column min-width="180" show-overflow-tooltip prop="endTime" label="直播结束时间"></el-table-column>
          <el-table-column min-width="180" show-overflow-tooltip prop="createdTime" label="发布时间"></el-table-column>
          <el-table-column label="是否推荐" header-align="center" align="center" min-width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.recommendFlag == 1">是</span>
              <span v-if="scope.row.recommendFlag == 0">否</span>
            </template>
          </el-table-column>
          <el-table-column min-width="130" show-overflow-tooltip prop="liveStatus" label="直播状态">
            <template slot-scope="scope">
              <div style="color: #EE1A1A;" v-if="scope.row.liveStatus == 1"> 待开播 </div>
              <div v-if="scope.row.liveStatus == 2">直播中</div>
              <div v-if="scope.row.liveStatus == 3">已结束</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center" width="250" min-width="250" fixed="right">
            <template slot-scope="scope">
              <el-button v-if="scope.row.liveStatus != 3" size="small" class="btn" type="primary" plain
                @click="computerLive(scope.row)">电脑开播</el-button>
              <el-button v-if="scope.row.liveStatus != 3" size="small" class="btn" type="primary" plain
                @click="openService(scope.row)">手机开播</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 分页 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <el-dialog title="手机直播" :visible.sync="dialogVisible" @close="handleCloseDialog">
      <div class="form">
        <!-- 显示后端返回的图片 -->
        <div class="image-container">
          <el-image :src="mpLiveUrl" class="live-image" :preview-src-list="[mpLiveUrl]"></el-image>
        </div>
        <div class="tips">请使用手机扫描二维码进入直播</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" type="primary" plain @click="handleCloseDialog">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="电脑直播" :visible.sync="dialogVisibleComputer" @close="handleCloseDialogComputer">
      <div class="computerDialog">
        <el-form :model="computer" ref="computer" class="demo-ruleForm" label-width="150px">
          <el-row>
            <el-col class="liveUrl">
              <el-form-item label="直播Url：">
                <div class="flex">
                  <el-input class="long-input" v-model="computer.liveUrl" readonly></el-input>
                  <div class="btns flex">
                    <el-button class="btn" type="primary" plain
                      @click="openComputerLiveUrl(computer.liveUrl)">打开</el-button>
                    <el-button class="btn" type="primary" plain
                      @click="copyToClipboard(computer.liveUrl)">复制</el-button>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="频道号：">
                <div class="flex">
                  <el-input v-model="computer.channelNumber" readonly></el-input>
                  <div class="btns flex">
                    <el-button class="btn" type="primary" plain
                      @click="copyToClipboard(computer.channelNumber)">复制</el-button>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="登录密码：">
                <div class="flex">
                  <el-input v-model="computer.livePassword" readonly></el-input>
                  <div class="btns flex">
                    <el-button class="btn" type="primary" plain
                      @click="copyToClipboard(computer.livePassword)">复制</el-button>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" type="primary" plain @click="handleCloseDialogComputer">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      liveName: "",
      status: "",
      statusOptions: [{
        label: '待开播',
        value: '1'
      },
      {
        label: '直播中',
        value: '2'
      },
      {
        label: '已结束',
        value: '3'
      },
      ], // 状态options
      // 表格数据
      tableData: [{ id: 1, switch: true }],
      // 分页
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）

      dialogVisible: false,
      mpLiveUrl: '',
      dialogVisibleComputer: false,
      computer: {
        liveUrl: '',
        channelNumber: '',
        livePassword: '',
      },
    }
  },
  created() {
    this.selectLiveInfoPage();
  },
  methods: {
    selectLiveInfoPage() {
      this.loading = true
      this.$axios
        .get(this.$api.selectLiveInfoPage, {
          params: {
            liveName: this.liveName || null,
            liveStatus: this.status || null,
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list || []
            this.totalItemsCount = res.result.totalCount
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 电脑开播
    computerLive(row) {
      this.computer = row;
      this.dialogVisibleComputer = true;
    },
    openComputerLiveUrl(liveUrl) {
      if (liveUrl && this.isValidUrl(liveUrl)) {
        window.open(liveUrl, '_blank');
      } else {
        this.$message.warning('无效的链接');
      }
    },
    // 复制到剪贴板
    copyToClipboard(text) {
      if (!text) {
        this.$message.warning('内容为空，无法复制');
        return;
      }
      // 创建临时输入框
      const tempInput = document.createElement('input');
      tempInput.value = text;
      document.body.appendChild(tempInput);
      // 选中并复制
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);
      this.$message.success('复制成功');
    },
    // 打开手机开播
    openService(row) {
      if (row.mpLiveUrl) {
        this.mpLiveUrl = row.mpLiveUrl
        this.dialogVisible = true;
      } else {
        return this.$message.warning('暂无链接！');
      }
    },
    // 检查 URL 是否以 http:// 或 https:// 开头的函数
    isValidUrl(url) {
      const regex = /^(https?:\/\/)/;
      return regex.test(url);
    },

    handleCloseDialog() {
      this.dialogVisible = false;
      this.mpLiveUrl = '';
    },
    handleCloseDialogComputer() {
      this.dialogVisibleComputer = false;
      this.computer = {}
    },
    // 清空
    clearData() {
      this.tableData = [];
      this.currentPage = 1;
    },
    // 搜索
    onSearch() {
      this.clearData();
      this.selectLiveInfoPage();
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.pageSize = e;
      this.onSearch();
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = [];
      this.currentPage = e;
      this.selectLiveInfoPage();
    },

  }

}
</script>

<style lang="scss" scoped>
.main {
  .form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* min-height: 450px; */
    padding: 20px;
    box-sizing: border-box;

    .live-image {
      max-width: 350px;
      max-height: 350px;
      object-fit: contain;
    }

    .tips {
      margin-top: 20px;
      font-size: 18px;
    }
  }

  .computerDialog {
    margin-left: 150px;
    margin-top: 30px;

    .btns {
      margin-left: 10px;
    }

    .flex {
      display: flex;
    }
  }
}
</style>
